export const ANALYTICS_EVENTS = {
  CITY_SELECTED: 'city_selected',
  FACILITY_SELECTED: 'facility_selected',
  QUESTION_ANSWERED: 'question_answered',
  CONTACT_WITH_COMPANY_INITIATED: 'contact_with_company_initiated',
};
